import request from "../request";

export const postApi = {
  listPost(params) {
    return request.get("/posts", { params: params });
  },
  savePost(data) {
    return request.post("/savePost", data);
  },
  deletePost(id) {
    return request.delete("/post/" + id);
  },
  getPost(id) {
    return request.get("/posts/" + id);
  },
  updatePost(id, data) {
    return request.put("/updatePost/" + id, data);
  },
};

export default postApi;
